const zhTW = {
  app: {
    title: '寶貝習慣園',
  },
  install: {
    title: '新增到主畫面，下次直接開啟',
    action: '立即安裝',
    iosHint: '點擊底部 分享按鈕，然後選擇「加入主畫面」',
  },
  common: {
    systemSettings: '系統設定',
    logout: '退出登入',
    logoutShort: '退出',
    current: '目前',
    close: '關閉',
    delete: '刪除',
    save: '儲存',
    saveSettings: '儲存設定',
    cancel: '取消',
    studentsCount: '{{count}} 位孩子',
    loading: '載入中...',
    confirm: '確定',
    prestigeReason: '完成了養成！🎉',
    add: '新增',
    all: '全部',
    unassigned: '未分組',
    networkError: '目前網路不可用，請檢查網路連線後再試',
    networkRestored: '網路已恢復，可以繼續操作',
  },
  petLife: {
    states: {
      normal: '狀態良好',
      hungry: '有點餓了',
      weak: '有些虛弱',
      dying: '快撐不住了',
      dead: '已沉睡',
    },
    hints: {
      normal: '持續加分就能保持活力。',
      hungry: '加分一次，就能恢復精神。',
      weak: '寵物有些虛弱，記得盡快加分餵養。',
      dying: '寵物狀態危險，需要盡快加分鼓勵。',
      dead: '寵物已經沉睡，給它加分就能喚醒。',
    },
  },
  settings: {
    tabs: {
      students: '孩子管理',
      items: '行為習慣',
      groups: '分組管理',
      growth: '成長配置',
      parentShare: '分享連結',
      checkin: '打卡任務',
      account: '基礎設定',
    },
    parentShare: {
      title: '分享連結',
      subtitle: '生成連結後分享，輸入孩子姓名即可查看「記錄 + 寵物圖鑑」',
      enabled: '已開啟',
      disabled: '已關閉',
      disabledHint: '關閉後打開連結會提示「已關閉查看功能」',
      processing: '處理中...',
      generateLink: '生成連結',
      copyLink: '複製連結',
      rotateLink: '重置連結',
      linkPlaceholder: '點擊「生成連結」後會顯示在這裡',
      tip: '建議：連結分享後，如需讓舊連結失效可點擊「重置連結」',
      footerHint: '生成連結分享，輸入姓名即可查看',
      toast: {
        generated: '連結已生成',
        generateFailed: '生成連結失敗',
        rotated: '連結已重置',
        rotateFailed: '重置連結失敗',
        copied: '連結已複製',
        copyFailed: '複製失敗',
      },
    },
    account: {
      changePassword: '修改密碼',
      currentClassName: '目前家庭名稱',
      classList: '家庭清單',
      addClass: '新增家庭',
      newClassPlaceholder: '例如：我的家庭',
      studentsCount: '{{count}} 位孩子',
      creating: '建立中...',
      create: '建立',
      deleteClass: '刪除家庭',
      desktop: {
        title: '新增到桌面',
        desc: '將寶貝習慣園新增到電腦桌面，下次直接雙擊開啟，無需輸入網址。',
        download: '下載桌面捷徑',
        hint: '下載後將檔案拖到桌面即可',
        filename: '寶貝習慣園',
      },
    },
    license: {
      permanent: '永久授權',
      validUntil: '有效期至：{{date}}',
    },
    language: {
      label: '語言',
      zhCN: '簡體中文',
      zhTW: '繁體中文',
      enUS: 'English',
    },
    footer: {
      hintAccount: '設定修改後點擊儲存生效',
      hintGrowth: '成長配置修改後點擊儲存生效',
      hintInstant: '此頁面操作立即生效',
    },
    icons: {
      honor: '榮譽',
      study: '學習',
      activity: '文體',
      nature: '自然',
      food: '美食',
      life: '生活',
    },
    growth: {
      title: '成長階段配置',
      subtitle: '設定每個階段所需的累計积分數量',
      level: '{{level}}級',
      tip: '說明：數字代表「累計獲得」的积分總數。例如5級設為30，表示孩子總共獲得30個积分時將升至5級。',
      errorNotIncreasing: '第{{level}}級的積分必須大於前一級',
    },
    sound: {
      title: '開啟音效',
      subtitle: '控制目前家庭的加分、升級等提示音是否啟用。',
    },
    petLife: {
      title: '衰減配置',
      subtitle: '設定連續多少天未加分後進入不同狀態。',
      enabled: '開啟衰減',
      disabled: '已關閉',
      enabledDesc: '寵物會根據未加分天數進入飢餓、虛弱等狀態',
      disabledDesc: '寵物永遠保持狀態良好',
      hungryAfterDays: '飢餓門檻',
      weakAfterDays: '虛弱門檻',
      dyingAfterDays: '瀕危門檻',
      sleepAfterDays: '沉睡門檻',
      reset: '恢復預設值',
      tip: '門檻必須遞增，系統會依自然日計算未加分天數。积分為負數時會立刻進入沉睡狀態；积分恢復到 0 及以上後，才依門檻規則顯示狀態。再次加分會立即恢復正常狀態（若积分仍為負，則仍顯示沉睡）。',
      rulePreview: '目前規則：{{hungryAfterDays}} 天進入飢餓，{{weakAfterDays}} 天進入虛弱，{{dyingAfterDays}} 天進入瀕危，{{sleepAfterDays}} 天進入沉睡。',
      skipWeekends: '週末（週六、週日）不計入衰減天數',
      validation: {
        order: '請輸入有效的遞增門檻：飢餓 < 虛弱 < 瀕危 < 沉睡，且都必須大於等於 1。',
      },
      preview: {
        title: '寵物狀態圖例預覽',
        hungry: '飢餓狀態',
        weak: '虛弱狀態',
        dying: '瀕危狀態',
        dead: '沉睡狀態',
        zoomHint: '點擊放大查看',
      },
    },
    items: {
      title: '行為習慣配置',
      subtitle: '設定行為習慣項目 ({{count}}個)。',
      hint: '(提示: 目前滿級需累計 {{maxPoints}} 分，請合理設定分值)',
      importSystemTemplate: '匯入系統模板',
      importSystemTemplateToast: '已匯入系統模板：新增 {{created}} 項，跳過 {{skipped}} 項',
      importSystemTemplateFailed: '匯入系統模板失敗',
      importSystemTemplateModal: {
        title: '匯入系統模板',
        desc: '將系統內建的打卡任務、加分項、減分項、小賣部商品追加到目前家庭，不會覆蓋現有項目。',
        confirm: '確認匯入',
        ageRangeLabel: '選擇年齡段',
        'ageRange_3-5': '3-5 歲',
        'ageRange_6-9': '6-9 歲',
        ageRange_10plus: '10+ 歲',
      },
      subTabs: {
        bonus: '加分項',
        deduction: '減分項',
      },
      newItemPlaceholder: {
        bonus: '項目名稱 (如: 按時起床、做家務)',
        deduction: '項目名稱 (如: 拖延、亂發脾氣)',
      },
      points: '{{points}} 分',
    },
    students: {
      title: '孩子名單',
      subtitle: '目前家庭共 {{count}} 人',
      bulkAdd: '📄 批量新增',
      bulkCancel: '取消批量',
      bulkHint: '每行輸入一個孩子姓名（最多50字），可直接從Excel貼上:',
      bulkPlaceholder: '張三\n李四\n王五',
      addAll: '新增全部',
      singlePlaceholder: '輸入孩子姓名...',
      bulkAddSuccess: '成功新增 {{count}} 名孩子',
      bulkAddFailed: '批量新增失敗',
      alreadyExists: '該孩子已存在',
      skipped: '成功新增 {{added}} 人，跳過 {{skipped}} 名重複孩子',
      allSkipped: '所有孩子均已存在，無需新增',
      deleteConfirm: {
        title: '確認刪除孩子?',
        descPrefix: '您確定要刪除 ',
        descSuffix: ' 嗎？',
        descLine2: '此操作無法撤銷。',
        confirm: '確認刪除',
      },
    },
    pets: {
      assign: {
        title: '一鍵分配寵物',
        subtitle: '隨機為所有孩子分配新的寵物',
        action: '執行分配',
      },
      assignConfirm: {
        title: '確認分配寵物?',
        descLine1: '確定要為所有未分配寵物的孩子隨機分配寵物嗎？',
        descLine2: '已分配的孩子不會受到影響。',
        confirm: '確認分配',
      },
      assignSuccess: '分配成功',
      assignFailed: '分配失敗',
      reset: {
        title: '重置家庭所有孩子進度',
        subtitle: '將清空積分、寵物、徽章、成長記錄與兌換記錄，且不可撤銷。',
        action: '重置家庭所有孩子進度',
        cleared: '會被清空',
        kept: '會被保留',
        clearedItems: {
          points: '積分',
          petSelection: '寵物選擇',
          petStage: '寵物階段',
          badges: '徽章',
          coins: '金幣',
          growthRecords: '成長記錄',
          exchangeRecords: '兌換記錄',
        },
        keptItems: {
          scoreRules: '加分減分規則',
          levelRules: '等級規則',
          className: '家庭名稱',
          groups: '分組',
          shopConfig: '販賣部配置',
        },
        warning: '本操作不可撤銷，將清空成長記錄與兌換記錄。若需留檔，請先匯出 CSV 備份。',
        passwordLabel: '請輸入登入密碼',
        passwordPlaceholder: '請輸入登入密碼以確認',
        confirm: '確認重置',
        success: '重置成功',
        failed: '重置失敗',
      },
    },
    import: {
      fromOtherClass: '從其他家庭匯入',
      success: '匯入成功',
      failed: '匯入失敗',
    },
    importModal: {
      title: '從其他家庭匯入配置',
      descPrefix: '選擇來源家庭，其',
      descSuffix: '將',
      override: '覆蓋',
      descEnd: '目前家庭的配置。',
      selectSourceClass: '選擇來源家庭',
      selectClassPlaceholder: '請選擇家庭...',
      confirm: '確認匯入',
    },
    save: {
      success: '儲存成功',
      failed: '儲存失敗',
    },
    update: {
      success: '更新成功',
      failed: '更新失敗',
    },
    delete: {
      success: '刪除成功',
      failed: '刪除失敗',
    },
    class: {
      createSuccess: '家庭建立成功',
      createFailed: '建立失敗',
      deleteSuccess: '家庭已刪除',
      deleteFailed: '刪除失敗，請稍後重試',
      deleteFailedHttp: '刪除失敗（HTTP {{status}}）',
      deleteNetworkError: '網路錯誤：{{message}}',
      deleteConfirm: {
        title: '確認刪除家庭?',
        descPrefix: '您確定要刪除 ',
        descSuffix: ' 嗎？',
        descLine2: '該家庭將不再顯示，需要輸入登入密碼確認。',
        passwordLabel: '登入密碼',
        passwordPlaceholder: '請輸入登入密碼',
        passwordError: '密碼錯誤，請重試',
        deleting: '刪除中...',
        confirm: '確認刪除',
      },
    },
    iconPicker: {
      title: '選擇圖示',
    },
    password: {
      title: '修改密碼',
      confirm: '確認修改',
      success: '密碼修改成功',
      error: {
        minLength: '新密碼至少需要6個字元',
        mismatch: '兩次輸入的密碼不一致',
        failed: '修改失敗，請檢查目前密碼',
      },
      currentPassword: {
        label: '目前密碼',
        placeholder: '請輸入目前密碼',
        hint: '請輸入您目前使用的密碼',
      },
      newPassword: {
        label: '新密碼',
        placeholder: '請設定新密碼',
        hint: '請設定新密碼，至少6個字元',
      },
      confirmPassword: {
        label: '確認新密碼',
        placeholder: '請再次輸入新密碼',
      },
    },
    groups: {
      title: '分組管理',
      subtitle: '共 {{count}} 個分組，最多 50 個',
      create: '新建分組',
      placeholder: '輸入分組名稱 (1-20字)',
      add: '新增',
      list: '分組列表',
      members: '小組成員',
      manageMembers: '管理小組成員',
      removeMember: '移出小組',
      random: {
        title: '隨機分組',
        studentCount: '目前孩子數量 {{total}} 個，執行隨機分組則把孩子隨機分成',
        label: '組',
        action: '重新隨機分組',
        confirmTitle: '確認隨機分組',
        confirmDesc: '將清除現有分組並按 {{count}} 組重新分配，是否繼續？',
        confirmAction: '繼續',
      },
      addStudent: {
        title: '新增孩子到「{{groupName}}」',
        placeholder: '搜尋孩子姓名',
        onlyUnassigned: '僅未分組',
        allowMultiple: '允許孩子同時屬於多個分組',
        selected: '可選 {{total}} 人, 已選 {{selected}} 人',
        selectAll: '全選/反選',
        clear: '清空',
        confirm: '確認新增 {{count}} 人',
        collapse: '收起',
      },
      deleteConfirm: {
        title: '確認刪除分組?',
        descPrefix: '您確定要刪除 ',
        descSuffix: ' 嗎？',
        desc: '刪除後，組內孩子將變為未分組狀態。',
        confirm: '確認刪除',
      },
      edit: '編輯分組',
    },
  },
  rank: {
    title: '光榮榜',
    selectClass: '選擇家庭',
    boardTitle: '{{className}} 積分排行榜',
    topHint: 'Top 20 優秀孩子',
    studentNumber: '編號',
    points: '積分',
    empty: '暫無排名資料',
  },
  petCenter: {
    title: '寵物中心',
    currentClass: '目前家庭',
    promptPetName: '替寶貝習慣園取個名字吧：',
    exp: 'EXP',
    mood: '心情',
    hunger: '飽食度',
    guardianPet: '家庭守護寵物',
    noPet: '該家庭尚未領養寵物哦',
    adoptNow: '立即領養',
    interactions: {
      title: '互動與照料',
      feed: {
        title: '餵食',
        desc: '消耗 10 積分，增加飽食度',
      },
      pet: {
        title: '撫摸',
        desc: '增加心情值（待開發）',
      },
      play: {
        title: '玩耍',
        desc: '消耗體力，增加經驗（待開發）',
      },
    },
    log: {
      title: '成長日誌',
      line1: '{{name}} 剛剛吃飽了，看起來很開心！',
      line2: '恭喜！{{name}} 升到了 Lv.{{level}}',
    },
  },
  classSelection: {
    title: {
      create: '建立新家庭',
      edit: '編輯家庭',
      manage: '家庭管理',
    },
    form: {
      className: '家庭名稱',
      placeholder: '例如：我的家庭',
      confirmCreate: '確認建立',
      saveChanges: '儲存修改',
    },
    footer: {
      createNew: '建立一個新家庭',
    },
  },
  leaderboard: {
    title: '光榮榜',
    subtitle: '養成寵物，榮登榜首',
    badges: '{{count}} 徽章',
    points: '{{count}} 積分',
    total: '總分',
    empty: '暫時還沒有資料哦',
    rule: '* 排名規則：1個徽章 = {{badgePointValue}}分 + 目前積分',
  },
  petSelection: {
    title: '選擇守護寵物',
    subtitle: '為 {{studentName}} 選一隻可愛的寵物吧',
    viewBaby: '查看幼崽形態',
    viewMax: '查看滿級形態',
    unlocked: '已養成',
    hint: '點擊選擇寵物，寵物會陪伴你完成每日打卡任務',
  },
  pets: {
    unknown: '未知寵物',
    hamster: '倉鼠',
    hedgehog: '刺蝟',
    unicorn: '獨角獸',
    phoenix: '鳳凰',
    dog: '小狗',
    dolphin: '海豚',
    fox: '狐狸',
    dinosaur: '恐龍',
    dragon: '小龍',
    cat: '小貓',
    owl: '貓頭鷹',
    raccoon: '浣熊',
    rabbit: '兔子',
    deer: '小鹿',
    panda: '熊貓',
    tiger: '老虎',
    elephant: '大象',
    monkey: '猴子',
    penguin: '企鵝',
    gorilla: '大猩猩',
    butterfly: '蝴蝶',
    chicken: '小雞',
    koala: '考拉',
    lion: '獅子',
    turtle: '烏龜',
    sheep: '小羊',
    bee: '蜜蜂',
    treant: '樹精',
    jellyfish: '水母',
    robot: '機器人',
    ultra: '鋼彈',
  },
  renamePet: {
    title: '給寵物起名',
    subtitle: '{{studentName}} · {{petName}}',
    label: '寵物暱稱',
    placeholder: '請輸入暱稱',
    hint: '僅支援 1-12 位中文/英文/數字',
    cancel: '取消',
    save: '儲存',
  },
  resetPassword: {
    title: '找回密碼',
    subtitle: '用啟用碼驗證後，就能設定一個新密碼',
    username: {
      label: '使用者名稱',
      placeholder: '請輸入使用者名稱',
    },
    code: {
      label: '啟用碼',
      placeholder: '例如：ABCD-YYYY-ZZZZ',
      hint: '請輸入您註冊時使用的啟用碼',
    },
    newPassword: {
      label: '新密碼',
      placeholder: '至少 6 個字元',
      hint: '請設定新密碼，至少6個字元',
    },
    confirmPassword: {
      label: '確認新密碼',
      placeholder: '請再次輸入新密碼',
    },
    processing: '處理中...',
    submit: '重設密碼',
    success: '密碼重設成功，請使用新密碼登入',
    error: {
      minLength: '新密碼至少需要6個字元',
      mismatch: '兩次輸入的密碼不一致',
      failed: '重設失敗，請檢查使用者名稱和啟用碼',
      foundUsername: '重設失敗。該啟用碼對應的使用者名稱是：{{username}}',
    },
  },
  growthRecords: {
    title: '成長紀錄',
    count: '{{shown}}/{{total}} 筆紀錄',
    exportCsv: '匯出 CSV',
    exportFilename: '成長紀錄_{{dateStr}}.csv',
    exportFailed: '匯出失敗',
    undo: '撤銷',
    undoFailed: '撤銷失敗',
    empty: '暫無紀錄',
    reverted: '（已撤銷）',
    unknownStudent: '未知孩子',
    csv: {
      time: '時間',
      student: '孩子',
      action: '操作',
      change: '變動',
    },
    confirmUndo: {
      title: '確認撤銷',
      defaultStudent: '該孩子',
      add: '加分',
      deduct: '扣分',
      desc: '將撤銷 {{name}} 的這條 {{action}} 紀錄，並產生一條撤銷紀錄。',
      confirm: '確認撤銷',
    },
    pagination: '第 {{current}}/{{totalPages}} 頁 · 共 {{totalItems}} 筆紀錄',
    tabs: {
      stats: '數據統計',
      history: '歷史紀錄',
    },
    stats: {
      week: '本週',
      month: '本月',
      lastMonth: '上月',
      custom: '自訂',
      query: '查詢',
      period: '{{start}} ~ {{end}}',
      totalGained: '總加分',
      totalLost: '總扣分',
      netChange: '淨變動',
      totalActions: '操作次數',
      activeStudents: '活躍孩子',
      studentRanking: '孩子排名',
      rank: '排名',
      student: '孩子',
      gained: '加分',
      lost: '扣分',
      net: '淨值',
      actions: '次數',
      dailyTrend: '每日趨勢',
      noData: '該時段暫無數據',
      exportFilename: '數據統計_{{period}}_{{dateStr}}.csv',
    },
  },
  studentAction: {
    batchMode: '批量操作模式',
    batchTitle: '替 {{count}} 位孩子評分',
    pointsUnit: '積分',
    availablePointsUnit: '可用',
    petsCountUnit: '隻寵物',
    currentExp: '目前經驗',
    changePet: '更換寵物',
    tabs: {
      action: '評分',
      calendar: '日曆',
      history: '紀錄',
      pets: '寵物',
    },
    calendar: {
      today: '今天',
      summary: '本月已打卡 {{count}} 次 · 共 {{points}} 分',
      empty: '本月暫無打卡紀錄',
    },
    searchPlaceholder: '搜尋加分/扣分項目...',
    checkinItems: '打卡項目',
    noCheckinTasks: '尚未設定打卡任務',
    positiveItems: '加分項目',
    negativeItems: '扣分項目',
    behaviorItems: '行為習慣',
    behaviorFilterAll: '全部',
    behaviorFilterPositive: '加分',
    behaviorFilterNegative: '扣分',
    noItemsFound: '未找到相關項目',
    custom: {
      label: '自訂',
      titlePositive: '自訂加分',
      titleNegative: '自訂扣分',
      points: '分數',
      pointsPlaceholder: '輸入分數',
      reason: '原因',
      optional: '(選填)',
      defaultPositive: '自訂加分',
      defaultNegative: '自訂扣分',
    },
    noHistory: '暫無評分紀錄',
    unknownAction: '未知操作',
    reverted: '（已撤銷）',
    undo: '撤銷',
    locked: '未解鎖',
    undoFailed: '撤銷失敗',
    export: '匯出紀錄',
    confirmUndo: {
      title: '確認撤銷',
      add: '加分',
      deduct: '扣分',
      desc: '將撤銷這條 {{action}} 紀錄，並產生一條撤銷紀錄。',
      confirm: '確認撤銷',
    },
    petStatus: {
      current: '目前狀態',
      daysWithoutFeed: '連續未加分',
      daysCount: '{{count}} 天',
      nextState: '距離下一狀態',
      toSleep: '距離沉睡',
      remainingDays: '{{count}} 天',
      awakenByPoints: '加分即可喚醒',
      sleepHint: '寵物等待新的鼓勵來恢復活力。',
      none: '—',
    },
  },
  store: {
    title: '兌換商店',
    selectClass: '選擇家庭',
    addGood: '上架商品',
    stock: '庫存: {{count}}',
    exchangeToStudent: '兌換給孩子',
    soldOut: '已售罄',
    empty: '暫無商品，快去上架吧',
    alert: {
      selectClassFirst: '請先選擇家庭',
      exchangeSuccess: '兌換成功！',
      exchangeFailed: '兌換失敗',
    },
    addModal: {
      title: '上架新商品',
      name: '商品名稱',
      price: '價格（積分）',
      stock: '庫存數量',
      confirm: '確認上架',
    },
    exchangeModal: {
      title: '兌換商品',
      desc: '正在兌換: {{name}} (消耗 {{price}} 積分)',
      selectClass: '選擇家庭',
      chooseClass: '請選擇家庭',
      selectStudent: '選擇孩子',
      chooseStudent: '請選擇兌換孩子',
      insufficient: '(積分不足)',
      studentOption: '{{name}} (積分: {{points}}) {{insufficient}}',
      confirm: '確認兌換',
    },
  },
  storeModal: {
    header: {
      storeTitle: '小賣部',
      manageTitle: '貨架管理',
      tips: '每養成一個寵物系統會發放10個金幣和1個徽章喔～',
    },
    tabs: {
      list: '商品清單',
      history: '紀錄',
      manageLong: '管理 商品',
      manageShort: '管理',
    },
    emptyList: '暫無商品上架',
    emptyListAction: '去新增商品',
    noDescription: '暫無描述',
    redeemNow: '立即兌換',
    soldOut: '已搶光',
    currentClass: '目前家庭：{{name}}',
    noClassSelected: '未選擇家庭',
    importFromOther: '從其他家庭匯入',
    stock: '庫存',
    edit: '編輯',
    addNew: '新增商品',
    noExchangeRecords: '暫無兌換紀錄',
    record: {
      defaultAvatar: '學',
      unknownStudent: '未知孩子',
      redeemed: '兌換了',
      unknownGood: '未知商品',
    },
    exchangeSelect: {
      title: '選擇兌換孩子',
      needCoins: '需要 {{price}} 可用積分',
      searchPlaceholder: '搜尋孩子姓名...',
      currentCoins: '目前擁有 {{coins}} 可用積分',
      insufficientCoins: '可用積分不足',
      clickRedeem: '點擊兌換',
      noStudentsFound: '未找到相關孩子',
    },
    confirmRedeem: {
      title: '確認兌換',
      desc: '確定要為 {{name}} 兌換 “{{goodName}}” 嗎?',
      cost: '將消耗 {{price}} 可用積分',
    },
    confirmDelete: {
      title: '確認刪除商品?',
      desc: '您確定要刪除 “{{name}}” 嗎？此操作無法撤銷。',
      deleting: '刪除中...',
      confirm: '確認刪除',
    },
    editModal: {
      editTitle: '編輯商品',
      addTitle: '上架新商品',
      name: '商品名稱',
      namePlaceholder: '例如：看電影券',
      description: '描述',
      descriptionPlaceholder: '例如：可以看一小時電視',
      price: '價格（可用積分）',
      initialStock: '份數',
      iconType: '圖示類型',
    },
    importModal: {
      title: '從其他家庭匯入商品',
      subtitle: '同步小賣部商品設定到目前家庭',
      sourceClass: '來源家庭',
      required: '必選',
      sourceClassPlaceholder: '請選擇要匯入的家庭（必選）',
      searchPlaceholder: '搜尋商品名稱...',
      selectAll: '全選',
      clear: '清空',
      selectedCount: '已選 {{selected}} / {{total}}',
      selectSourceClassFirst: '請選擇來源家庭',
      noImportableGoods: '暫無可匯入商品',
      importing: '匯入中...',
      startImport: '開始匯入',
    },
    toast: {
      outOfStock: '庫存不足',
      insufficientCoins: '可用積分不足',
      redeemSuccess: '兌換成功！{{name}} 已兌換「{{goodName}}」',
      redeemFailed: '兌換失敗',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      enterName: '請輸入商品名稱',
      enterPrice: '請輸入商品價格',
      enterStock: '請輸入初始庫存',
      selectClassFirst: '請先選擇家庭',
      fetchClassesFailed: '取得家庭清單失敗',
      fetchSourceGoodsFailed: '取得來源家庭商品失敗',
      selectSourceClass: '請選擇來源家庭',
      selectAtLeastOneGood: '請至少選擇一個商品',
      importDone: '匯入完成：新增{{created}}，更新{{updated}}，跳過{{skipped}}',
      importFailed: '匯入失敗',
    },
  },
  classManagement: {
    title: '家庭管理',
    create: {
      button: '新增家庭',
      title: '建立新家庭',
      placeholder: '請輸入家庭名稱',
      confirm: '確認建立',
    },
    edit: {
      title: '編輯家庭資訊',
      placeholder: '家庭名稱',
      save: '儲存修改',
    },
    delete: {
      title: '刪除家庭',
      willDelete: '即將刪除：{{name}}',
      desc: '此操作會讓該家庭在你的系統中不可見，且需要輸入登入密碼確認。',
      passwordLabel: '請輸入登入密碼',
      passwordPlaceholder: '登入密碼',
      confirm: '確認刪除',
      errorFallback: '刪除失敗，請稍後重試',
    },
    sidebar: {
      title: '我的家庭',
      empty: '暫無家庭，請先建立',
    },
    studentsTotal: '孩子總數: {{count}} 人',
    addStudent: {
      button: '新增孩子',
      name: '姓名',
      studentNumber: '編號（選填）',
    },
    table: {
      name: '姓名',
      studentNumber: '編號',
      points: '目前積分',
      actions: '操作',
      edit: '編輯',
      empty: '暫無孩子資料',
    },
    noClassSelected: '請選擇左側家庭查看詳情',
  },
  login: {
    appName: '寶貝習慣園',
    tagline1: '每天進步一點點，寵物就會長大一點點',
    tagline2: '完成任務拿積分，解鎖新夥伴',
    tabs: {
      login: '登入',
      register: '註冊',
    },
    username: {
      label: '使用者名稱',
      placeholder: '請輸入使用者名稱(可為手機號或英文名)',
    },
    password: {
      label: '密碼',
      placeholder: '請輸入密碼',
      show: '顯示密碼',
      hide: '隱藏密碼',
    },
    activationCode: {
      label: '啟用碼',
      placeholder: '請輸入系統啟用碼',
      hint: '啟用碼由系統管理員分發，用於驗證身份',
    },
    renewCode: {
      label: '新的啟用碼（用於續期）',
      placeholder: '請輸入新的啟用碼',
      hint: '續期成功後會自動登入',
    },
    processing: '處理中...',
    submit: {
      login: '立即登入',
      register: '立即註冊',
      renewAndLogin: '續期並登入',
    },
    forgotPassword: '忘記密碼？用啟用碼找回 ➜',
    switch: {
      noAccount: '還沒有帳號？',
      hasAccount: '已有帳號？',
      toRegister: '去註冊',
      toLogin: '去登入',
    },
    errors: {
      expired: '帳號已過期，請輸入新的啟用碼續期後登入',
      failed: '登入失敗，請再試一次',
    },
    rememberMe: '記住使用者名稱',
  },
  home: {
    selectClass: '選擇家庭',
    searchPlaceholder: '搜尋孩子...',
    nav: {
      store: '小賣部',
      leaderboard: '光榮榜',
      reports: '報告',
      settings: '設定',
      tools: '工具',
    },
    tools: {
      title: '常用工具',
      random: {
        title: '隨機抽獎',
        action: '開始抽獎',
        rolling: '抽取中...',
        reset: '重置',
        result: '抽到了：{{name}}',
        count: '抽取人數',
        review: '評價',
        excludePicked: '不重複抽取',
        remaining: '剩餘 {{count}} 人',
        resetPicked: '重置',
      },
      timer: {
        title: '倒數計時/計時',
        countdown: '倒數計時',
        stopwatch: '正向計時',
        start: '開始',
        pause: '暫停',
        reset: '重置',
        minutes: '分鐘',
        seconds: '秒',
        timeUp: '時間到！',
        custom: '自定義',
        set: '設定',
        placeholder: '輸入分鐘數(如0.5)或MM:SS(如0:30)',
      },
      noise: {
        title: '噪音檢測',
        sensitivity: '靈敏度',
        level: '當前噪音',
        hint: '請允許使用麥克風以檢測噪音',
      },
    },
    sort: {
      score: '按分數',
      name: '按名字',
    },
    viewMode: {
      compact: '小圖模式',
      normal: '普通模式',
    },
    lock: {
      button: '鎖屏',
      locked: '鎖定',
      unlockButton: '解鎖',
      setTitle: '設定密碼',
      confirmTitle: '確認密碼',
      unlockTitle: '輸入密碼解鎖',
      setHint: '請輸入4位數字密碼',
      confirmHint: '請再次輸入4位數字密碼',
      unlockHint: '請輸入鎖屏密碼',
      cancel: '取消',
      wrong: '密碼錯誤，請重試',
      mismatch: '兩次輸入不一致，請重新設定',
      saveSuccess: '鎖屏密碼設定成功',
      saveFailed: '鎖屏密碼儲存失敗',
      changePassword: '修改密碼',
      verifyTitle: '驗證原密碼',
      verifyHint: '請輸入當前鎖屏密碼',
      changeSuccess: '鎖屏密碼修改成功',
    },
    batch: {
      enter: '批量',
      exit: '退出',
      hint: '點擊卡片選擇孩子，然後批量餵養',
      selectedPrefix: '已選擇',
      selectedSuffix: '人',
      selectAll: '全選',
      deselectAll: '取消全選',
      clear: '清空',
      feed: '批量餵養',
    },
    empty: {
      noClasses: {
        title: '還沒有建立家庭',
        desc: '建立一個家庭開始你的成長之旅吧！你可以新增孩子、管理積分和寵物。',
        action: '立即建立家庭',
      },
      noStudents: {
        title: '家庭還沒有孩子',
        desc: '快去新增孩子，開始寶貝習慣園之旅吧！',
        action: '新增孩子',
      },
    },
    student: {
      adopt: '點擊領養',
      mysteryEgg: '神秘蛋',
      progress: '本級進度',
      hatching: '等待孵化',
      maxLevel: '已滿級',
      remaining: '還差 {{count}}',
      changePet: '更換',
      daysWithoutFeed: '未加分',
      daysCount: '{{count}} 天',
      nextStateIn: '距離下一狀態還有 {{count}} 天',
      sleepIn: '距離沉睡還有 {{count}} 天',
      sleepHint: '寵物已經沉睡，給它加分就能喚醒',
      waitingWakeUp: '等待新的鼓勵來恢復活力',
    },
    summon: '召喚守護寵物',
    feedback: {
      batchSuccess: '批量操作成功',
      addSuccess: '加分成功',
      deductSuccess: '扣分成功',
      appliedTo: '已套用到 {{count}} 位孩子',
    },
    levelUp: {
      maxTitle: '滿級啦！',
      levelUpTitle: '升級啦！',
      promote10: '晉升 10 級',
      maxAchieved: '⭐ 滿級達成 ⭐',
      promoteN: '晉升 {{level}} 級',
      maxForm: '已達最強形態',
      stronger: '變得更強了',
      footer: '{{name}} 的寵物{{status}}',
    },
    prestige: {
      title: '養成成功！',
      congrats: '恭喜 {{name}}',
      petBadge: '⭐ 守護寵物 · 滿級形態 ⭐',
      badgeReward: '獲得養成徽章 +1',
      coinsReward: '獲得金幣 +10',
      note: '✨ 徽章將永久保存在你的收藏中 ✨',
      later: '稍後再說',
      collect: '收集徽章',
    },
  },
  parentShare: {
    title: '查看詳情',
    titleWithClass: '{{className}} · 查看詳情',
    loading: '載入中...',
    invalidLink: '連結無效或已過期',
    disabledMessage: '已關閉查看功能，請聯繫家長重新開啟',
    points: '積分：{{points}}',
    nameLabel: '孩子姓名',
    namePlaceholder: '請輸入孩子姓名',
    nameHint: '請與家長設定的孩子姓名完全一致（含編號/符號）。例如設定為「01李四」，這裡也需輸入「01李四」。',
    submit: '查看',
    searching: '查詢中...',
    lookupFailed: '查詢失敗，請稍後重試',
    currentExp: '目前經驗',
    tabs: {
      history: '記錄',
      pets: '寵物',
    },
    emptyHistory: '暫無記錄',
    revertedSuffix: ' · 已撤銷',
    catalogTitle: '寵物圖鑑',
    ownedCount: '已養成：{{count}}',
    owned: '已養成',
    locked: '未解鎖',
    noPet: '暫無寵物',
    footerNote: '本頁面僅用於查看寵物資訊',
  },
  checkin: {
    title: '每日打卡',
    todayProgress: '今日進度 {{done}}/{{total}}',
    complete: '完成',
    completed: '已完成',
    undo: '取消打卡',
    taskManagement: '打卡任務管理',
    taskManagementSubtitle: '設定每日打卡任務 ({{count}}個)',
    addTask: '添加任務',
    weekdayShort: {
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六',
      sun: '日',
    },
    form: {
      addTitle: '新建打卡任務',
      editTitle: '編輯打卡任務',
      name: '任務名稱',
      points: '獎勵積分',
      dateRange: '起止日期',
      dateHint: '留空表示不限制開始或結束日期',
      dateNoLimit: '長期有效',
      dateRangeInvalid: '開始日期不能晚於結束日期',
      clearDates: '清除',
      repeat: '重複日期',
      repeatRequired: '至少選擇一天',
      preset: {
        all: '全選',
        weekdays: '工作日',
        weekend: '週末',
      },
    },
    taskName: '任務名稱',
    taskNamePlaceholder: '例如：刷牙、閱讀30分鐘',
    taskPoints: '獎勵積分',
    noTasks: '還沒有設置打卡任務，去設置中添加吧',
    noChildren: '請先添加孩子',
    history: '打卡記錄',
    deleteTitle: '刪除打卡任務',
    deleteConfirm: '確定要刪除任務「{{name}}」嗎？',
    toast: {
      completeSuccess: '打卡成功！',
      completeFailed: '打卡失敗',
      uncompleteSuccess: '已取消打卡',
      uncompleteFailed: '取消打卡失敗',
      taskCreated: '任務創建成功',
      taskCreateFailed: '任務創建失敗',
      taskDeleted: '任務已刪除',
      taskDeleteFailed: '刪除任務失敗',
    },
  },
  onboarding: {
    title: '歡迎來到寶貝習慣園',
    subtitle: '先新增一個孩子，開始養成之旅吧',
    nameLabel: '寶貝暱稱',
    namePlaceholder: '例如：糖糖',
    ageRangeLabel: '寶貝年齡段',
    ageRangeHint: '我們會依年齡段自動匯入合適的打卡任務、行為習慣與小賣部商品',
    'ageRange_3-5': '3-5 歲',
    'ageRange_6-9': '6-9 歲',
    ageRange_10plus: '10+ 歲',
    create: '建立寶貝',
    creating: '建立中...',
    errors: {
      nameRequired: '請輸入寶貝暱稱',
      createFailed: '建立失敗，請稍後再試',
    },
  },
  reports: {
    title: '家庭週報',
    empty: '本期沒有資料',
    exportImage: '匯出圖片',
    preset: {
      thisWeek: '本週',
      lastWeek: '上週',
      thisMonth: '本月',
      lastMonth: '上月',
    },
    card: {
      totalPoints: '總積分',
      availablePoints: '可用',
      gained: '加分',
      lost: '扣分',
      net: '淨增',
      gainedShort: '加',
      lostShort: '扣',
      topBonus: 'TOP 加分',
      topDeduction: 'TOP 扣分',
      checkinRate: '打卡完成率',
      redemptions: '兌換紀錄',
      noRedemptions: '本期無兌換',
    },
    toast: {
      fetchFailed: '取得報告失敗',
    },
  },
};

export default zhTW;
